<template>
    <div>
        <loading
            :active.sync="loadingContent"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <router-link :to="{ name: 'home' }" class="headerButton">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </router-link>
            </div>
            <div class="pageTitle">Deposit Saldo</div>
        </div>
        <!-- * App Header -->

        <div id="appCapsule">
            <!-- Form -->
            <div class="section inset mt-2">
                <div class="form-group boxed pt-0">
                    <div class="input-wrapper">
                        <label class="label">Nominal</label>
                        <input
                            type="tel"
                            class="form-control form-control-lg"
                            v-model="data.nominal"
                            @input="inputNominal"
                        />
                        <i class="clear-input">
                            <ion-icon
                                name="close-circle"
                                @click="clearNominal()"
                            ></ion-icon>
                        </i>
                    </div>
                    <div
                        class="input-info"
                        v-if="customer.account_verified == null"
                    >
                        <ion-icon name="information-circle"></ion-icon> Maksimal
                        Nominal Rp 200.000
                    </div>
                </div>
                <div
                    class="form-group basic pb-0"
                    style="white-space: nowrap; overflow: auto"
                >
                    <button
                        v-for="item in nominal"
                        :key="item"
                        class="btn btn-outline-primary btn-sm mr-1 mb-1"
                        style="border-radius: 50px; border: 1px solid"
                        @click="inputNominal(item)"
                    >
                        <ion-icon name="add-circle"></ion-icon> Rp
                        {{ item | rupiah }}
                    </button>
                </div>
            </div>

            <div class="section full">
                <!-- QRIS -->
                <div
                    v-if="
                        payment.filter(data => data.type_payment == 'QRIS')
                            .length > 0
                    "
                >
                    <div class="listview-title">QRIS</div>
                    <ul class="listview image-listview-product inset">
                        <li
                            v-for="item in payment.filter(
                                data => data.type_payment == 'QRIS'
                            )"
                            :key="item.id"
                        >
                            <a
                                class="item"
                                @click="showActionSheet('show', item)"
                                :class="
                                    item.status_mutasi == 0
                                        ? 'disabled-product'
                                        : ''
                                "
                            >
                                <img
                                    :src="
                                        VUE_ENV.VUE_APP_ASSET_URL +
                                        '/img/payment/' +
                                        item.payment_logo
                                    "
                                    alt="image"
                                    class="image"
                                />
                                <div class="in">
                                    <div>
                                        {{ item.payment_name }}
                                        <footer>{{ item.information }}</footer>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
                <!-- Bank Transfer -->
                <div
                    v-if="
                        payment.filter(
                            data => data.type_payment == 'BANK_TRANSFER'
                        ).length > 0
                    "
                >
                    <div class="listview-title mt-1 pl-3 pr-3">
                        Bank Transfer
                    </div>
                    <ul class="listview image-listview-product inset">
                        <li
                            v-for="item in payment.filter(
                                data => data.type_payment == 'BANK_TRANSFER'
                            )"
                            :key="item.id"
                        >
                            <a
                                class="item pl-3 pr-3"
                                @click="showActionSheet('show', item)"
                                :class="
                                    item.status_mutasi == 0
                                        ? 'disabled-product'
                                        : ''
                                "
                            >
                                <img
                                    :src="
                                        VUE_ENV.VUE_APP_ASSET_URL +
                                        '/img/payment/' +
                                        item.payment_logo
                                    "
                                    alt="image"
                                    class="image"
                                />
                                <div class="in">
                                    <div>
                                        {{ item.payment_name }}
                                        <footer>{{ item.information }}</footer>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
                <!-- Virutal Account  -->
                <div
                    v-if="
                        payment.filter(
                            data => data.type_payment == 'VIRTUAL_ACCOUNT'
                        ).length > 0
                    "
                >
                    <div class="listview-title mt-1">Virtual Account</div>
                    <ul class="listview image-listview-product inset">
                        <li
                            v-for="item in payment.filter(
                                data => data.type_payment == 'VIRTUAL_ACCOUNT'
                            )"
                            :key="item.id"
                        >
                            <a
                                class="item pl-3 pr-3"
                                @click="showActionSheet('show', item)"
                                :class="
                                    item.status_mutasi == 0
                                        ? 'disabled-product'
                                        : ''
                                "
                            >
                                <img
                                    :src="
                                        VUE_ENV.VUE_APP_ASSET_URL +
                                        '/img/payment/' +
                                        item.payment_logo
                                    "
                                    alt="image"
                                    class="image"
                                />
                                <div class="in">
                                    <div>
                                        {{ item.payment_name }}
                                        <footer>{{ item.information }}</footer>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
                <!-- Mini Market -->
                <div
                    v-if="
                        payment.filter(
                            data => data.type_payment == 'MINIMARKET'
                        ).length > 0
                    "
                >
                    <div class="listview-title mt-1">Mini Market</div>
                    <ul class="listview image-listview-product inset">
                        <li
                            v-for="item in payment.filter(
                                data => data.type_payment == 'MINIMARKET'
                            )"
                            :key="item.id"
                        >
                            <a
                                class="item pl-3 pr-3"
                                @click="showActionSheet('show', item)"
                                :class="
                                    item.status_mutasi == 0
                                        ? 'disabled-product'
                                        : ''
                                "
                            >
                                <img
                                    :src="
                                        VUE_ENV.VUE_APP_ASSET_URL +
                                        '/img/payment/' +
                                        item.payment_logo
                                    "
                                    alt="image"
                                    class="image"
                                />
                                <div class="in">
                                    <div>
                                        {{ item.payment_name }}
                                        <footer>{{ item.information }}</footer>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
                <!-- E-Money -->
                <div
                    v-if="
                        payment.filter(data => data.type_payment == 'EMONEY')
                            .length > 0
                    "
                >
                    <div class="listview-title mt-1">E-Money</div>
                    <ul class="listview image-listview-product inset">
                        <li
                            v-for="item in payment.filter(
                                data => data.type_payment == 'EMONEY'
                            )"
                            :key="item.id"
                        >
                            <a
                                class="item"
                                @click="showActionSheet('show', item)"
                                :class="
                                    item.status_mutasi == 0
                                        ? 'disabled-product'
                                        : ''
                                "
                            >
                                <img
                                    :src="
                                        VUE_ENV.VUE_APP_ASSET_URL +
                                        '/img/payment/' +
                                        item.payment_logo
                                    "
                                    alt="image"
                                    class="image"
                                />
                                <div class="in">
                                    <div>
                                        {{ item.payment_name }}
                                        <footer>{{ item.information }}</footer>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
                <!-- Lainnya -->
                <div
                    v-if="
                        payment.filter(data => data.type_payment == 'LAINNYA')
                            .length > 0
                    "
                >
                    <div class="listview-title mt-1">Lainnya</div>
                    <ul class="listview image-listview-product inset">
                        <li
                            v-for="item in payment.filter(
                                data => data.type_payment == 'LAINNYA'
                            )"
                            :key="item.id"
                        >
                            <a
                                class="item"
                                @click="showActionSheet('show', item)"
                                :class="
                                    item.status_mutasi == 0
                                        ? 'disabled-product'
                                        : ''
                                "
                            >
                                <img
                                    :src="
                                        VUE_ENV.VUE_APP_ASSET_URL +
                                        '/img/payment/' +
                                        item.payment_logo
                                    "
                                    alt="image"
                                    class="image"
                                />
                                <div class="in">
                                    <div>
                                        {{ item.payment_name }}
                                        <footer>{{ item.information }}</footer>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- * Form Deposit -->
        </div>

        <action-sheet ref="modal" :title="'Konfirmasi Deposit'" :inset="true">
            <div class="form-group basic">
                <label class="label">Nominal</label>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Rp</span>
                    </div>
                    <input
                        type="text"
                        class="form-control form-control-lg"
                        :value="data.nominal | rupiah"
                        readonly
                    />
                </div>
            </div>

            <div class="form-group basic">
                <label class="label">Metode Pembayaran</label>
                <input
                    type="text"
                    class="form-control form-control-lg"
                    :value="data.payment_name"
                    readonly
                />
            </div>

            <div class="form-group basic">
                <ButtonLoader
                    :loading="loadingButton"
                    :styled="'btn btn-primary btn-block btn-lg'"
                    @click.native="submit()"
                    >Tiket Deposit</ButtonLoader
                >
            </div>
        </action-sheet>

        <Dialog
            ref="dialog_update_apk"
            :loading="false"
            :title="'Update Aplikasi'"
            @confirm="updateApk()"
        >
            Aplikasi versi terbaru telah tersedia di playstore. Update Sekarang!
        </Dialog>
        <Dialog
            ref="dialog_available_waiting"
            :loading="false"
            :title="'Deposit Gagal'"
            :icon="'danger'"
            @confirm="redirectToDepositAvailable()"
        >
            Masih ada deposit saldo sebelumnya yang belum terbayarkan, silahkan
            selesaikan terlebih dahulu deposit tersebut dengan melakukan
            pembayaran atau membatalkannya. Ingin melihat detail deposit?
        </Dialog>
    </div>
</template>
<script>
    import $axios from './../api.js';
    import { mapState } from 'vuex';
    // import Loading from 'vue-loading-overlay';
    // import 'vue-loading-overlay/dist/vue-loading.css';
    export default {
        // components: {
        //     Loading
        // },
        data() {
            return {
                loadingButton: false,
                loadingContent: true,
                nominal: [10000, 50000, 100000, 500000, 1000000, 2000000],
                data: {
                    nominal: '',
                    payment_id: '',
                    payment_name: '',
                },
                payment: [],
                deposit_id_available: '',
            };
        },
        computed: {
            ...mapState(['customer', 'toast', 'VUE_ENV']),
        },
        methods: {
            updateApk() {
                this.dialogUpdateAPK('hide');
                window.open(
                    'https://play.google.com/store/apps/details?id=com.digifazz.app',
                    '_blank'
                );
            },
            dialogUpdateAPK(value) {
                let element = this.$refs.dialog_update_apk.$el;
                window.$(element).modal(value);
            },
            inputNominal(nominal) {
                this.$store.commit('RESET_TOAST');
                if (this.data.nominal == '') {
                    this.data.nominal = '0';
                }
                if (nominal == undefined) {
                    const nominal_request = parseInt(this.data.nominal);
                    this.data.nominal = this.$options.filters.inputRupiah(
                        nominal_request.toString()
                    );
                } else {
                    const nominal_request =
                        parseInt(this.data.nominal.replace(/[^,\d]/g, '')) +
                        nominal;
                    this.data.nominal = this.$options.filters.inputRupiah(
                        nominal_request.toString()
                    );
                }
            },
            clearNominal() {
                this.data.nominal = '';
            },
            showActionSheet(value, payment) {
                this.$store.commit('RESET_TOAST');
                this.data.nominal = this.data.nominal.replace(/[^,\d]/g, '');
                if (payment.status_mutasi == 1) {
                    if (this.data.nominal > 0) {
                        if (
                            this.$store.getters.isMaxTopup(
                                Number(this.data.nominal)
                            )
                        ) {
                            if (
                                (this.data.nominal >= payment.min_topup &&
                                    this.data.nominal <= payment.max_topup) ||
                                this.customer.role == 'H2H'
                            ) {
                                this.data.payment_id = payment.id;
                                this.data.payment_name = payment.payment_name;
                                let element = this.$refs.modal.$el;
                                window.$(element).modal(value);
                            } else {
                                this.$store.commit('SET_TOAST', {
                                    show: true,
                                    message:
                                        'Nominal deposit minimal Rp ' +
                                        this.$options.filters.inputRupiah(
                                            payment.min_topup.toString()
                                        ) +
                                        ' - ' +
                                        this.$options.filters.inputRupiah(
                                            payment.max_topup.toString()
                                        ),
                                    tipe: 'default',
                                    icon: 'danger',
                                });
                            }
                        } else {
                            this.$store.commit('SET_TOAST', {
                                show: true,
                                message:
                                    'Maksimal nominal deposit saldo Anda adalah Rp ' +
                                    this.$options.filters.inputRupiah(
                                        this.VUE_ENV.VUE_APP_MAX_TOPUP.toString()
                                    ) +
                                    '. Segera Verifikasi Data Diri Anda untuk untuk menghindari batas deposit saldo.',
                                tipe: 'default',
                                icon: 'danger',
                            });
                        }
                    } else {
                        this.$store.commit('SET_TOAST', {
                            show: true,
                            message: 'Masukkan nominal deposit',
                            tipe: 'default',
                            icon: 'danger',
                        });
                    }
                } else {
                    this.$store.commit('SET_TOAST', {
                        show: true,
                        message:
                            'Sedang gangguan, silahkan coba beberapa saat lagi',
                        tipe: 'default',
                        icon: 'warning',
                    });
                }
            },
            hideActionSheet() {
                let element = this.$refs.modal.$el;
                window.$(element).modal('hide');
            },
            getPayment() {
                $axios.get('/payment').then(response => {
                    this.payment = response.data.data;
                    this.loadingContent = false;
                });
            },
            submit() {
                this.loadingButton = true;
                $axios
                    .post('/deposit', this.data)
                    .then(response => {
                        this.loadingButton = false;
                        this.hideActionSheet();
                        this.$router.push({
                            name: 'transaction.deposit.show',
                            params: { id: response.data.data.id },
                        });
                    })
                    .catch(e => {
                        this.loadingButton = false;
                        this.hideActionSheet();
                        if (
                            e.response.status == 400 &&
                            e.response.data.responseCode == 'AVAILABLE_UPDATE'
                        ) {
                            this.dialogUpdateAPK('show');
                        } else {
                            if (
                                e.response.data.message ==
                                'Masih ada deposit saldo sebelumnya yang belum terbayarkan.'
                            ) {
                                this.deposit_id_available =
                                    e.response.data.data.id;
                                let element =
                                    this.$refs.dialog_available_waiting.$el;
                                window.$(element).modal('show');
                            } else {
                                this.$store.commit('SET_TOAST', {
                                    show: true,
                                    message: e.response.data.message,
                                    tipe: 'default',
                                    icon: 'danger',
                                });
                            }
                        }
                    });
            },
            redirectToDepositAvailable() {
                let element = this.$refs.dialog_available_waiting.$el;
                window.$(element).modal('hide');
                this.$router.push({
                    name: 'transaction.deposit.show',
                    params: { id: this.deposit_id_available },
                });
            },
        },
        mounted() {
            this.getPayment();
        },
        destroyed() {
            this.$store.commit('RESET_TOAST');
        },
        filters: {
            inputRupiah: function (value) {
                var number_string = value.replace(/[^,\d]/g, '').toString(),
                    split = number_string.split(','),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);

                if (ribuan) {
                    var separator = sisa ? '.' : '';
                    rupiah += separator + ribuan.join('.');
                }

                rupiah =
                    split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
                return rupiah;
            },
        },
    };
</script>
